// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2f1adc2","239":"ac5aecde","667":"dfd0222c"}[chunkId] + ".chunk.js";
};